import { useEffect } from "react";

/**
 * Substract END (valorB tag) value from START (valorA tag) value
 * and set the result to TOTAL (valorC tag) for each row.
 */
export const useValorCalc = ({
  sectionTag,
  tag,
  rowIndex,
  id,
  setValue,
}: {
  sectionTag: string | undefined;
  tag: string | undefined;
  rowIndex: number | undefined;
  id: string;
  setValue: (id: string, value: string) => void;
}) => {
  if (
    sectionTag !== "ValorCalcs" ||
    !tag?.startsWith("valor") ||
    rowIndex === undefined
  )
    return;
  useEffect(() => {
    const calcDiff = () => {
      if (rowIndex === undefined) return;
      const valorA = document.querySelector<HTMLInputElement>(
        `div.valorA_${rowIndex} > input`,
      )?.value;
      const valorB = document.querySelector<HTMLInputElement>(
        `div.valorB_${rowIndex} > input`,
      )?.value;
      const diff = parseInt(valorA ?? "0") - parseInt(valorB ?? "0");
      if (tag === "valorC") {
        // Defer setValue to prevent interfering with tab navigation
        setTimeout(() => {
          setValue(
            id,
            diff !== null && !isNaN(diff) ? diff.toFixed(0).toString() : "",
          );
        }, 0);
      }
    };

    calcDiff();

    // Attach blur event listener on valor inputs blurr
    const inputs =
      document.querySelectorAll<HTMLInputElement>(`div.valor > input`);
    inputs?.forEach(input => input.addEventListener("blur", calcDiff));

    return () => {
      inputs?.forEach(input => input.removeEventListener("blur", calcDiff));
    };
  }, []);
};
